const BASE_URL = import.meta.env.VITE_BASE_URL;
const XIAOJI_GPT_URL = import.meta.env.VITE_XIAOJI_GPT_URL;
const XIAOWEN_GPT_URL = import.meta.env.VITE_XIAOWEN_GPT_URL;
const platformAuthorizeHost = 'https://authorization.jinhuibb.com';
// 中台服务后台
const MSSV_ADMIN_URL = import.meta.env.VITE_MSSV_ADMIN_URL;
// 录单后台
const ORDER_RECORD_ADMIN_URL = import.meta.env.VITE_ORDER_RECORD_ADMIN_URL;
// 大数据
const BIG_DATA_URL = import.meta.env.VITE_BIG_DATA_URL;
const pathList: Array<{ name: string; paths: { [propName: string]: string }; baseUrl?: string }> = [
  {
    name: 'config',
    paths: {
      getGlobalConfig: '/global/config',
    },
  },
  {
    name: 'user',
    baseUrl: '', // 可不指定
    paths: {
      getToken: '/token',
      getUserInfo: '/admin/user/info',
      getState: '/cs/info',
      changeState: '/cs/state',
      getUserMenu: '/admin/menu/user',
    },
  },
  {
    name: 'oss',
    paths: {
      getSTSToken: '/sts_token',
    },
  },
  {
    name: 'chat',
    paths: {
      getQWPersonalMsgList: '/qywx/receive_list',
      getQWGroupMsgList: '/qywx/team_receive_list',
      getGZHPersonalMsgList: '/official/receive_list',
      getGZHGroupMsgList: '/official/team_receive_list',
      getH5PersonalMsgList: '/cs/receive_list',
      getH5GroupMsgList: '/cs/team_receive_list',
      // 机器人接待列表
      getCSRobotReceiveList: '/cs/robot_receive_list',
      getQWMsgRoaming: '/admin/qywx/msg_roaming',
      foreignPayment: '/order',
      foreignPaymentGroup: '/order/group',
      orderPrepareCreate: '/order/prepare/create',
      orderBusiness: '/order/business',
      csAddressCollect: '/cs/address_collect',
      csBatchClose: '/cs/receive/close',
      getCsConsultingType: '/cs/consulting_type',
      updateConsultingType: '/cs/session/consulting_type',
      getCsSessionArchivesAll: '/cs/session/archives/all',
      updateCsSessionArchives: '/cs/session/archives',
      getOrderListUnify: '/order/list/unify',
      getWorkbenchOrderSelf: '/workbench/order/self',
      getWorkbenchOrderSelfNum: '/workbench/order/self/order_num',
      getOrderRefundBase: '/order/refund/base',
      getOrderRefundOrder: '/order/refund/order',
      orderRefundCreate: '/order/refund/create',
      getReservation: '/cs/session/reservation',
      csSessionMark: '/cs/session/mark',
      csBatchTransfer: '/cs/batch_transfer',
      receiveLabel: '/receive_label',
      receiveLabelInfo: '/receive_label/info/:id',
      receiveLabelCreate: '/receive_label/create',
      receiveLabelUpdate: '/receive_label/update',
      receiveLabelDelete: '/receive_label/delete',
      receiveLabelRelate: '/receive_label/relate',
      receiveLabelPreview: '/receive_label/preview',
      receiveLabelReceiveList: '/receive_label/receive_list',
      aiAssistantInstruction: '/ai/assistant/instruction',
      csGuideWechat: '/cs/guide/wechat',
      csSessionGuide: '/cs/session/guide',
      //翻译
      csTranslation: '/cs/translation',
      translateText: '/translate/text',
    },
  },
  {
    name: 'contact',
    paths: {
      // 联系人发起会话
      csCreateReceive: '/cs/receive/create',
      // 第三方联系人群发消息
      customerGroupSendMsg: '/admin/qywx/customer/group_send_msg',
      // 极速群发
      customerRapidSendMsg: '/admin/qywx/customer/rapid_send_msg',
    },
  },
  {
    name: 'setting',
    paths: {
      // 公众号管理
      official: '/official',
      // 企业微信管理
      microWechat: '/admin/qywx',
      // 企业微信机器人
      microWechatRobot: '/admin/qywx/robot',
      microWechatRobotFilter: '/admin/qywx/robot/filter',
      // 我的机器人
      getCSMyRobotList: '/cs/my_robot',
      // 企微绑定员工
      getCorpAuthQrcode: '/corp/auth/qrcode',
      corpManualBindRobot: '/corp/manual/bind/robot',
      // 企微主体列表
      microCorpList: '/corp',
      // 接入服务商企微
      providerCorp: '/provider/corp',
      // 机器人激活许可
      providerActive: '/provider/active',
      // 企微客户
      corpCustomer: '/corp/customer',
      // 机器人客户绑定企微客户
      corpBindRobotCustomer: '/corp/bind/robot_customer',
      // 同步企微客户
      corpSyncCustomer: '/corp/sync/customer',
      // 同步机器人信息
      syncRobotInfo: '/admin/qywx/sync/robot_info',
      // 企微授权
      corpAuthCallBack: '/corp/auth/callback',
      // 机器人群聊列表
      robotGroupList: '/admin/qywx/group',
      // 一键创建群聊
      addGroupByCustomer: '/admin/qywx/group/custom',
      // 机器人关注群聊
      robotFollowGroup: '/admin/qywx/group/follow',
      // 机器人登录日志
      robotLoginLog: '/admin/qywx/robot/:robot_id/log',
      // 机器人客户列表
      robotCustomerList: '/admin/qywx/robot_customer_unify',
      // 机器人下线
      robotLogout: '/admin/qywx/logout',
      // 机器人登录二维码
      getrobotQrCode: '/admin/qywx/qrcode',
      // 机器人登录验证码
      robotLoginValidate: '/admin/qywx/login_validate',
      // 服务商机器人登录二维码
      getRobotProviderCode: '/admin/qywx/provider/oauth2',
      // 根据手机号搜索用户
      getOfficialUser: '/admin/qywx/search',
      // 企业微信根据手机号添加好友
      addOfficialUser: '/admin/qywx/add',
      // 异步拉取群聊成员列表
      syncGetCustomer: '/admin/qywx/sync/customer',
      // 用户管理
      user: '/admin/user',
      // 角色管理
      role: '/admin/role',
      // 角色绑定多个用户
      roleUserBind: '/admin/role/user/bind',
      // 修改角色菜单
      updateRoleMenu: '/admin/role/menu',
      // 菜单管理
      menu: '/admin/menu',
      // 权限管理
      permission: '/admin/permission',
      adminTeamVisibleRange: '/admin/team/:TEAMID/visible_range',
      removeAdminTeamVisibleRange: '/admin/team/:TEAMID/visible_range/:ID',

      // 统一机器人列表
      adminQYWXUnify: '/admin/qywx/unify',
      adminQYWXRobotExpireCount: '/admin/qywx/robot/expire_count',
      // 统一主体列表
      corpUnify: '/corp/unify',
      // 第三方机器人绑定统一机器人
      adminQYWXUnifyBind: '/admin/qywx/unify_bind',
      // 许可订单列表
      corpLicenseOrder: '/corp/license/order',
      transferLicense: '/admin/qywx/transfer_license',
      // 团队权限配置
      adminTeamSecurityGet: '/admin/team/security/get',
      adminTeamSecuritySet: '/admin/team/security/set',
      // 机器人标签
      robotTagList: '/robot_tag/list',
      robotTagCreate: '/robot_tag/create',
      robotTagEdit: '/robot_tag/edit',
      robotTagDelete: '/robot_tag/delete',
      robotTagRelate: '/robot_tag/relate',
      robotTagSort: '/robot_tag/sort',
    },
  },
  {
    name: 'material',
    paths: {
      getQuickReplyClassifyTree: '/cs/quick_reply/classify/tree',
      // 快捷回复分类管理
      quickReplyClassify: '/cs/quick_reply/classify',
      getQuickReplyList: '/cs/quick_reply/list',
      quickReplyOne: '/cs/quick_reply',
      quickReplyDetail: '/cs/quick_reply/info',
      quickReplySort: '/cs/quick_reply/sort',
      csQuickReplyImport: '/cs/quick_reply/import',
      csQuickReplySyncZhiNi: '/cs/quick_reply/sync_zhini',
      csQuickReplySortClassify: '/cs/quick_reply/sort/classify',
      // 企微标签
      userTagProvider: '/user_tag/provider',
      userTagProviderMulti: '/user_tag/provider/multi',
      customerManageWechatRemoveTag: '/customer/manage/wechat/remove_tag',
      // 用户标签
      userTag: '/user_tag',
      userTagGroup: '/user_tag/group',
      // 用户标签分组列表仅分组
      userTagGroupList: '/user_tag/group_list',
      userTagGroupBind: '/user_tag/group/bind',
      // 咨询标签
      consultTypeTag: '/consulting_type',
      // 渠道活码
      liveCode: '/live_code',
      liveCodeStatistics: '/live_code/statistics',
      liveCodeUpdateChannel: '/livecode/update/channel',
      liveCodeUpdateMulti: '/livecode/update/multi',
      downloadLiveCodeStatistics: '/download/livecode_statistics',
      downloadSceneStatistics: '/download/scene_statistics',
      downloadSceneRobotStatistics: '/download/scene_robot_statistics',
      downloadLiveCodeImage: '/download/livecode_image',
      liveCodeGetByRobot: '/livecode/get_by_robot',
      liveCodeReplaceRobot: '/livecode/replace_robot',
      // liveCodeUpdate: '/live_code/update',
      getLiveCodeQuota: '/live_code/quota',
      // 强导流列表
      businessLiveCode: '/business_livecode',
      businessLiveCodeFans: '/business_livecode/fans',
      // 非强导流列表
      businessLiveCodeSoftList: '/business_livecode/soft/list',
      businessLiveCodeSoft: '/business_livecode/soft',
      businessLiveCodeSoftDel: '/business_livecode/soft/del',
      businessLiveCodeSoftUpdate: '/business_livecode/soft/update',
      businessLiveCodeQuota: '/business_livecode/quota',
      // 获取机器人绑定的欢迎语
      robotBindWelcomeMessage: '/welcome_message/bind',
      // 获取欢迎语绑定机器人列表
      getWelcomeMessagePlanRobotList: '/welcome_message/plan/:id/robot',
      // 群聊欢迎语
      getGroupWelcomeMsg: '/group_welcome_msg/group',
      getGroupWelcomeMsgSpeak: '/group_welcome_msg/group/speak',
      createGroupWelcomeMsg: '/group_welcome_msg/create',
      updateGroupWelcomeMsg: '/group_welcome_msg/update',
      getGroupWelcomeMsgList: '/group_welcome_msg/list',
      getGroupWelcomeMsgInfo: '/group_welcome_msg/info',
      deleteGroupWelcomeMsg: '/group_welcome_msg/delete',
      syncGroupWelcomeMsg: '/group_welcome_msg/sync',
      updateGroupWelcomeMsgSpeak: '/group_welcome_msg/update/speak',
      // 获取机器人绑定的自动回复
      robotBindAutoReponse: '/auto_response/bind',
      // 自动回复方案
      autoResponsePlan: '/auto_response/plan',
      // 获取自动回复绑定的机器人列表
      getAutoResponsePlanRobotList: '/auto_response/plan/:id/robot',
      // 获取历史朋友圈
      adminQYWXMoment: '/admin/qywx/moment',
      // 朋友圈点赞
      adminQYWXMomentLike: '/admin/qywx/moment/:id/like',
      // 朋友圈评论
      adminQYWXMomentComment: '/admin/qywx/moment/:id/comment',
      // 团队小程序
      adminTeamApplets: '/admin/team/applets',
      getLeaveComments: '/leave_comments',
      leaveCommentsHandle: '/leave_comments/handle',
      leaveCommentsHandleFinish: '/leave_comments/handle/finish',
      leaveCommentsContact: '/leave_comments/contact',
      getEvaluationList: '/evaluation',
      sensitive: '/sensitive',
      sensitiveImport: '/sensitive/import',
      // 新运营计划
      newUserList: '/new_user/list',
      newUserCreate: '/new_user/create',
      newUserUpdate: '/new_user/update',
      newUserInfo: '/new_user/info',
      newUserDelete: '/new_user/delete',
      newUserGroup: '/new_user/group',
      newUserLog: '/new_user/log',
      newUserChange: '/new_user/change',
      // 雷达链接
      radarLinkCreate: '/radar_link/create',
      radarLinkUpdate: '/radar_link/update',
      radarLinkList: '/radar_link',
      radarLinkDetail: '/radar_link/:id',
      radarLinkDelete: '/radar_link/delete',
      radarLinkIncr: '/radar_link/incr',
      // AI语音合成
      voiceSynthesisObject: '/voice_synthesis/object',
      voiceSynthesis: '/voice_synthesis',
      // 获客链接
      customerQcquisitionCreate: '/customer_acquisition/create',
      customerQcquisitionUpdate: '/customer_acquisition/update',
      customerQcquisitionDelete: '/customer_acquisition/delete',
      customerQcquisitionList: '/customer_acquisition/list',
      customerQcquisitionInfo: '/customer_acquisition/info',
      // 用户属性
      attributeAll: '/attribute/all',
      attributeInfo: '/attribute/info/:id',
      attributeCreate: '/attribute/create',
      attributeUpdate: '/attribute/update',
      attributeDelete: '/attribute/delete',
      attributeCategory: '/attribute/category',
      attributeUpdateCategory: '/attribute/update/category',
      sessionAttribute: '/session_attribute',
      // 规则标签
      userTagRuleList: '/user_tag_rule/list',
      userTagRuleCreate: '/user_tag_rule/create',
      userTagRuleUpdate: '/user_tag_rule/update',
      userTagRuleDelete: '/user_tag_rule/delete',
      userTagRuleInfo: '/user_tag_rule/info/:id',
      // 活码场景
      sceneList: '/scene/list',
      sceneInfo: '/scene/info/:id',
      sceneCreate: '/scene/create',
      sceneUpdate: '/scene/update',
      sceneDelete: '/scene/delete',
      sceneSetting: '/scene/setting',
      sceneUpdateName: '/scene/update/name',
      sceneAuthorized: '/scene/authorized',
      businessLiveCodeStatisticsDate: '/business_livecode/statistics/date',
      businessLiveCodeStatisticsCombination: '/business_livecode/statistics/combination',
      businessLiveCodeStatisticsAll: '/business_livecode/statistics/all',
      businessLiveCodeDashboard: '/business_livecode/dashboard',
      sceneSearchByRobot: '/scene/search_by_robot',
      sceneReplaceRobot: '/scene/replace/robot',
      sceneReplaceWelcomeMsgTagRule: '/scene/replace/welcome_msg_tag_rule',
      // 渠道活码
      liveCodeList: '/livecode/list',
      liveCodeCreate: '/livecode',
      liveCodeUpdate: '/livecode/update',
      liveCodeDelete: '/livecode/:id',
      liveCodeDetail: '/livecode/:id',
      liveCodeSetting: '/livecode/setting',
      liveCodeUser: '/livecode/user',
      liveCodeStatisticsDate: '/livecode/statistics/date',
      liveCodeStatisticsAll: '/livecode/statistics/all',
      liveCodeDashboard: '/livecode/dashboard',
      liveCodeDashboardRobot: '/livecode/dashboard/robot',
      liveCodeEnable: '/livecode/enable_or_disable',
      liveCodeAbnormalRobot: '/livecode/abnormal_robot/:id',
      liveCodeAuthorized: '/livecode/authorized',
      // 引导加粉明细
      csGuideWechatDetail: '/cs/guide/wechat/detail',
      // 我的主体
      csMyCorp: '/cs/my_corp',
      // 添加好友任务
      addFriendTask: '/add_friend/task',
      // 智能推送
      intelligentPushList: '/intelligent_push/list',
      intelligentPushCount: '/intelligent_push/count',
      intelligentPushCreate: '/intelligent_push/create',
      intelligentPushInfo: '/intelligent_push/info/:ID',
      intelligentPushCancel: '/intelligent_push/cancel',
      intelligentPushDetail: '/intelligent_push/detail',
      intelligentPushChangeStatus: '/intelligent_push/change_status',
    },
  },
  {
    name: 'seaspool',
    paths: {
      // 公海池管理
      pool: '/pool',
      poolUserList: '/pool/:id/user',
      poolUserAssign: '/pool/:pool_id/:pool_user_id/assign',
      poolUserBatchAssign: '/pool/:pool_id/user/batch_assign',
      poolUserRecycle: '/pool/user/:id/recycle',
      poolCustomer: '/pool/customer',
      poolRecycleUserById: '/pool/:pool_id/:pool_user_id/recycle',
      poolChatMsg: '/pool/chat_msg',
      getPoolUserByTeam: '/pool/team/user',
      getCallList: '/call/list',
      callAssign: '/call/assign',
      callSource: '/call/source',
      callAgent: '/call/agent',
      callListSelect: '/call/list/select',
      callImport: '/call/import',
      callAddFriend: '/call/add_friend',
    },
  },
  {
    name: 'customer',
    paths: {
      getMyClientList: '/cs/my_client',
      updateUserReceive: '/admin/user/receive',
      deleteClientById: '/cs/client/:id',
      shieldClientById: '/cs/client/:id/blacklist',
      getClientInfo: '/cs/session/remark',
      getVirtualRobotUpServiceLocus: '/virtual_robot/up_service/locus',
      getDecryptInfo: '/cs/session/decrypt/info',
      bindClientPhone: '/cs/session/bind/:session_id/phone',
      bindClientEmail: '/cs/session/bind/:session_id/email',
      bindClientUserTag: '/cs/session/bind/:session_id/user_tag',
      getCSRobotCustomer: '/cs/robot/customer',
      csMyClientBatchReceive: '/cs/my_client/batch_receive',
      csMyClientBatchTag: '/cs/my_client/batch_tag',
      bindOrder: '/order/bind',
      getClientDetail: '/cs/my_client/detail',
      csMyClientCount: '/cs/my_client/count',
      csMyClientUpdateWechatRemark: '/cs/my_client/update_wechat_remark',
    },
  },
  {
    name: 'team',
    paths: {
      // 数据权限控制的客服列表
      getMyCustomer: '/cs/my_customer',
      getTeamCustomer: '/admin/team/customer',
      // 团队管理
      team: '/admin/team',
      // 团队配置管理
      teamGroup: '/admin/team/group',
      // 团队配置-H5-增减成员
      teamGroupMember: '/admin/team/group/member',
      // 团队接入渠道
      teamChannel: '/admin/team/channel',
      // 获取团队绑定公众号/微信
      getTeamBindWechat: '/admin/team/wechat',
      // 团队绑定公众号/企业微信
      teamBindWechat: '/admin/team/wechat/bind',
      // 团队解绑公众号/微信
      teamUnBindWechat: '/admin/team/wechat/unbind',
      // 修改公众号负责人
      teamWechatManager: '/admin/team/wechat/manager',
      // 团队智能聊天机器人
      teamWechatSmartChatRobot: '/admin/team/wechat/smart_chat_robot',
      // 团队所有微信客服
      wechatKFMyWechatKF: '/wechat_kf/my_wechat_kf',
      // 智能聊天机器人列表
      smartChatRobotList: '/smart_chat_robot/list',
      // 获取智能聊天机器人团队资产
      smartChatRobotTeamRelationList: '/smart_chat_robot/team/relation',
      // 获取机器人与智能聊天机器人绑定列表
      smartChatRobotBind: '/smart_chat_robot/bind',
      // 获取智能聊天机器人团队资产
      smartChatRobotTeamAssets: '/smart_chat_robot/team/assets',
      // 获取智能聊天机器人未绑定列表
      smartChatRobotUnboundList: '/smart_chat_robot/unbound',
      smartChatRobotTeamStatus: '/smart_chat_robot/team/status',
      smartChatRobotUnBundle: '/smart_chat_robot/unbundle',
      // 获取团队外部账号
      getExternalUserTeam: '/external/user/team',
      // 外部账号
      addExternalUser: '/external/user',
      updateExternalUser: '/external/user/update',
      removeExternalUser: '/external/user/remove',
      externalLogin: '/token/external_login',
      externalResetPassword: '/token/reset_password',
      externalUserResetPassword: '/external/user/reset/:external_user_id',
      // 更新团队的支付渠道
      updateTeamPaymentChannel: '/admin/team/update/payment_channel',
      // 更新团队跨团队对接
      updateEnableTeamCross: '/admin/team/:id/switch',
      teamTransferMemberList: '/admin/team/transfer_member_list',
      teamTransferMemberGroupList: '/admin/team/transfer_member_group_list',
      // 团队成员分组
      teamMemberGroup: '/admin/team/member_group',
      teamMemberGroupChange: '/admin/team/member_group/manage',
      updateTeamMemberCsName: '/admin/team/change/cs_name',
      teamChangeMemberPost: '/admin/team/change/member/post',
      teamChnageSpecialRemark: '/admin/team/change/special_remark',
      //团队虚拟机器人
      robotList: '/virtual_robot/list',
      robotInfo: '/virtual_robot/info',
      updateRobot: '/virtual_robot/update',
      createRobot: '/virtual_robot/create',
      // 团队资产
      adminTeamAssets: '/admin/team/assets',
      // 团队支付渠道
      teamPaymentChannel: '/admin/team/payment_channel',
      // 本团队成员
      adminTeamMembers: '/admin/team/members',
    },
  },
  {
    name: 'group',
    paths: {
      wechatGroup: '/wechat/group',
      wechatGroupAddMember: '/wechat/group/add_member',
      wechatGroupKickout: '/wechat/group/kickout',
      wechatGroupAddAdmin: '/wechat/group/add_admin',
      wechatGroupRemoveAdmin: '/wechat/group/remove_admin',
      wechatGroupUpdateName: '/wechat/group/update_name',
      wechatGroupProtectName: '/wechat/group/protect_name',
      wechatGroupInviteConfirm: '/wechat/group/invite_confirm',
      wechatGroupUpdateNickname: '/wechat/group/update_nickname',
      wechatGroupAddFriend: '/wechat/group/add_friend',
      wechatGroupTransfer: '/wechat/group/transfer',
      wechatGroupAnnouncement: '/wechat/group/announcement',
      wechatGroupSyncMember: '/wechat/group/sync_member',
      wechatGroupInfo: '/wechat/group/info',
      wechatGroupMemberInfo: '/wechat/group/member_info',
      wechatGroupMemberRemark: '/wechat/group/member_remark',
      wechatGroupReceiveId: '/wechat/group/receive_id',
      groupBindGroupTag: '/cs/group/bind/:groupId/group_tag',
    },
  },
  {
    name: 'robot',
    paths: {
      getRobotSkillList: '/smart_chat_robot/skill',
      updateRobotSkillSwitch: '/smart_chat_robot/skill/:collectionId/switch',
      bindRobotSkill: '/smart_chat_robot/skill/:collectionId/bind',
      addRobotSkill: '/smart_chat_robot/skill',
      robotSkillDetail: '/smart_chat_robot/skill/:collectionId',
      getSkillLabelList: '/smart_chat_robot/skill/label',
      addSkillLabel: '/smart_chat_robot/skill/:collectionId/label',
      getAILabelList: '/smart_chat_robot/skill/ai_label',
      getDefaultAnswer: '/smart_chat_robot/skill/default_answer',
      submitRobotAnswer: '/smart_chat_robot/skill/:collectionId/answer',
      getAnswerExampleDetail: '/smart_chat_robot/skill/answer/:exampleId',
      updateAnswerExample: '/smart_chat_robot/skill/answer/:exampleId',
      getSkillLabelDetail: '/smart_chat_robot/skill/label/:labelId',
      getCandidateExample: '/smart_chat_robot/skill/candidate_example',
    },
  },
  {
    name: 'favorites',
    paths: {
      favorites: '/favorites',
    },
  },
  {
    name: 'msg',
    paths: {
      bindMsg: '/bind/chatcontent',
    },
  },
  {
    name: 'conversation',
    paths: {
      history: '/cs/artificial/history',
      robotHistory: '/cs/robot/history',
      reStartChat: '/cs/receive/again',
      dmChatMsgMark: '/dm/chat_msg_mark',
      dmEditLabel: '/dm/edit_label',
      dmFinish: '/dm/finish',
      dmSlotOptions: '/dm/slot_options',
      dmEditSlot: '/dm/edit_slot',
      dmErrorSlot: '/dm/error_slot',
    },
  },
  {
    name: 'applets',
    paths: {
      applets: '/admin/team/applets',
      miniProgramCode: '/mini_program/qrcode',
    },
  },
  {
    name: 'statistical',
    paths: {
      getStatisticsReceive: '/statistics/receive',
      getOrderList: '/order/list',
      getOrderInfoDetail: '/order/state/:orderId',
      getOrderSummary: '/order/summary',
      getConsultTypeReport: '/consulting_type/report',
      getHistoryReceiveList: '/statistics/receive/history',
      getHistoryReceivePersonalList: '/statistics/receive/history/summary/personal',
      getHistorySummaryReceiveList: '/statistics/receive/history/summary',
      getOverviewReceiveList: '/statistics/receive/overview',
      getReceiveNumOverview: '/statistics/diagram/receive_num/overview',
      getMsgNumOverview: '/statistics/diagram/msg_num/overview',
      getLinghitOrder: '/order/linghit',
      relateLinghitOrder: '/order/seeronnet/relate',
      getLiveCodeStatistics: '/business_livecode/statistics',
      getStatisticsCustomerServiceDaily: '/statistics/customer_service/daily',
      getStatisticsCustomerServiceCityDaily: '/statistics/customer_service/city/daily',
    },
  },
  {
    name: 'workspace',
    paths: {
      transferCustomerTask: '/transfer_customer/task',
      transferCustomerTaskFull: '/transfer_customer/task/full',
      transferCustomerCustomerList: '/transfer_customer/customer/list',
      transferCustomerTaskList: '/transfer_customer/task/list',
      transferCustomerTaskInfo: '/transfer_customer/task/info',
      transferCustomerTaskDetail: '/transfer_customer/task/detail',
      corpAutoBindRobotCustomer: '/corp/auto_bind/robot_customer',
      trafficPool: '/traffic_pool',
      trafficPoolWorkingTimes: '/traffic_pool/working_times',
      welcomeMessageH5: '/welcome_message/h5',
      welcomeMessageH5Status: '/welcome_message/h5/:ID/status',
      welcomeMessageH5Default: '/welcome_message/h5/default',
      welcomeMessageH5Logs: '/welcome_message/h5/:ID/logs',
      welcomeMessageH5DefaultLogs: '/welcome_message/h5/default/logs',
      advancedPushList: '/advanced_push/list',
      advancedPushInfo: '/advanced_push/info/:ID',
      advancedPushCreate: '/advanced_push/create',
      advancedPushCount: '/advanced_push/count',
      advancedPushSubTask: '/advanced_push/sub_task/:ID',
      advancedPushSubTaskCancel: '/advanced_push/sub_task/cancel',
      advancedPushSubTaskSplit: '/advanced_push/sub_task/split',
      advancedPushDetailList: '/advanced_push/detail/list',
      advancedPushSetting: '/advanced_push/setting',
      advancedPushSettingSave: '/advanced_push/setting/save',
      advancedPushUpdateStaus: '/advanced_push/update/status',
      robotUserStatisticsSummary: '/robot_user_statistics/summary',
      robotUserStatisticsDate: '/robot_user_statistics/date',
      robotUserStatisticsDashBoardSummary: '/robot_user_statistics/dashboard/summary',
      robotUserStatisticsDashBoardSlider: '/robot_user_statistics/dashboard/slider',
      robotUserStatisticsDashBoardBehavior: '/robot_user_statistics/dashboard/behavior',
      robotUserStatisticsDashBoardFansSlider: '/robot_user_statistics/dashboard/fans/slider',
      robotuserStatisticsDashboardFansDay: '/robot_user_statistics/dashboard/fans/day',
      speedGroupSendList: '/speed_send/list',
      speedGroupSendCancel: '/speed_send/cancel',
      speedGroupSendCreate: '/speed_send/create',
      speedGroupSendCount: '/speed_send/count',
      speedGroupSendInfo: '/speed_send/info/:ID',
      speedGroupSendDetail: '/speed_send/detail',
      speedGroupSendRemind: '/speed_send/remind',
      speedGroupSendNotice: '/speed_send/notice',
      robotUserStatisticsDashBoardSummaryCurrent: '/robot_user_statistics/dashboard/summary/current',
      welcomeMessagePlan: '/welcome_message/plan',
      welcomemessagePlanLogs: '/welcome_message/plan/:ID/logs',
      autoTaggingList: '/auto_tagging/list',
      autoTaggingCreate: '/auto_tagging/create',
      autoTaggingEdit: '/auto_tagging/edit',
      autoTaggingInfo: '/auto_tagging/info/:ID',
      autoTaggingDelete: '/auto_tagging/delete',
      autoTaggingChange: '/auto_tagging/change',
      momentTask: '/admin/qywx/moment_task',
      momentTaskList: '/admin/qywx/moment_tasks',
      momentTaskCancel: '/admin/qywx/moment_task/:ID/cancel',
      momentTaskLog: '/admin/qywx/moment_task/:ID/log',
      adminQYWXMomentTaskCount: '/admin/qywx/moment_task/count',
      momentTaskStatistics: '/admin/qywx/moment_task/:ID/statistics',
      businessModel: '/business_model',
      // 微信客服
      wechatKFCorp: '/wechat_kf/corp',
      wechatKFAccount: '/wechat_kf/account',
      wechatKFAccountLink: '/wechat_kf/account/:ID/link',
      wechatKFAccountBind: '/wechat_kf/account/:ID/bind',
      updateWechatKFLink: '/wechat_kf/account/link/:ID',
      wechatKFAuthLink: '/wechat_kf/auth_link',
      // 有生成链接的客服账号列表
      wechatKFAccountWithLink: '/wechat_kf/account_with_link',
      // 上传企微临时素材
      wechatUpload: '/upload',
      // 场景池
      scenePoolRule: '/scene_pool/rule',
      scenePool: '/scene_pool',
      scenePoolRuleLink: '/scene_pool/rule/:ID/link',
      scenePoolRuleBind: '/scene_pool/:ID/bind',
      scenePoolWorkingTimes: '/scene_pool/working_times',
      // 客服分流规则
      adminTeamDiversionRules: '/admin/team/diversion_rules',
      // 单向好友
      unilateralCustomerList: '/unilateral_customer/list',
      unilateralCustomerCreate: '/unilateral_customer/create',
      unilateralCustomerDetail: '/unilateral_customer/detail',
      unilateralCustomerLog: '/unilateral_customer/log',
      unilateralCustomerCancel: '/unilateral_customer/cancel',
      // 机器人接待
      userOceanEntrCollect: '/user_ocean/entr_collect',
      userOceanQueue: '/user_ocean/queue',
      userOceanXiaoling: '/user_ocean/xiaoling',
      userOceanChatMsg: '/user_ocean/chat_msg',
      userOceanPoolMember: '/user_ocean/pool/member',
      userOceanDispatch: '/user_ocean/dispatch',
      // 通知配置管理
      dingtalkRobot: '/dingtalk_robot',
      onlineNoticeConfig: '/online_notice_config',
      messageNoticeConfig: '/message_notice_config',
      // 预约列表
      appointmentDispatchList: '/appointment_dispatch/list',
      appointmentDispatchDetail: '/appointment_dispatch/detail',
      appointmentDispatchUpdate: '/appointment_dispatch/update',
      // 预约单
      appointmentDispatchConfCreate: '/appointment_dispatch/conf/create',
      appointmentDispatchConfUpdate: '/appointment_dispatch/conf/update',
      appointmentDispatchConfList: '/appointment_dispatch/conf/list',
      appointmentDispatchConfDetail: '/appointment_dispatch/conf/detail',
      // 日程管理
      appointmentScheduleManagement: '/appointment_dispatch/schedule/management',
      appointmentScheduleTable: '/appointment_dispatch/schedule/table',
      appointmentCustomer: '/appointment_dispatch/customer',
      appointmentDetection: '/appointment_dispatch/detection',
      appointmentService: '/appointment_dispatch/service',
      appointmentSignIn: '/appointment_dispatch/sign_in',
      appointmentQuick: '/appointment_dispatch/quick',
      // 获取自己的转接人员可见范围
      getCsVisibleList: '/cs/visible',
      dingtalkRobotAbnormalMonitor: '/dingtalk_robot/abnormal_monitor',
      // 微信客服统计
      WechatKFSummary: '/statistics/wechat_kf/summary',
      WechatKFMonthSummary: '/statistics/wechat_kf/month/summary',
      // 过滤词
      filterWords: '/filter_words',
      filterWordsImport: '/filter_words/import',
      // 一人一号
      userDisRelate: '/user_distributary/relate',
      userDisRelateState: '/user_distributary/relate/state',
      userDisRelateRobot: '/user_distributary/relate/robot',
      userDisSetting: '/user_distributary/setting',
      userDisSettingState: '/user_distributary/setting/state',
      userDisBackUpSetting: '/user_distributary/backup/setting',
      // 社群数据统计
      providerGroupOwnerSummary: '/statistics/provider_group/owner/summary',
      providerGroupSummary: '/statistics/provider_group/summary',
      providerGroupOwnerMonthSummary: '/statistics/provider_group/owner/month/summary',
      providerGroupMonthSummary: '/statistics/provider_group/month/summary',
      // 设置升级服务
      virtualRobotUpService: '/virtual_robot/up_service',
      virtualRobotUpServiceRemove: '/virtual_robot/up_service/:robot_id',
      // 推荐企微
      csGuideWeChatSetting: '/cs/guide/wechat/setting',
      csGuideWeChatNotConfigured: '/cs/guide/wechat/setting/not_configured',
      // 客户管理
      customerManageWechat: '/customer/manage/wechat',
      customerManageWechatKF: '/customer/manage/wechat_kf',
      customerManageVirtual: '/customer/manage/virtual',
      customerManageWechatEditTag: '/customer/manage/wechat/edit_tag',
      customerManageWechatCorp: '/customer/manage/wechat/corp',
      customerManageWechatTaskList: '/customer/manage/wechat/task_list',
      customerManageWechatAddTag: '/customer/manage/wechat/add_tag',
      // 机器人话术配置
      robotTalkConfList: '/robot_talk/conf/list',
      robotTalkConf: '/robot_talk/conf',
      robotTalkConfQa: '/robot_talk/conf/:id/qa',
      robotTalkConfFqa: '/robot_talk/conf/:id/fqa',
      robotTalkTaskFlow: '/robot_talk/task_flow',
      robotTalkXLSX: '/robot_talk/xlsx',
      // 联系码
      adminQYWXRobotQrcode: '/admin/qywx/robot/qrcode',
      // 外部群管理
      externalGroupList: '/external_group/list',
      externalGroupInfo: '/external_group/info',
      // 个人数据面板
      persoanlDashboardCreate: '/personal_dashboard/create',
      personalDashboardDelete: '/personal_dashboard/delete',
      persoanlDashboardList: '/personal_dashboard/list',
      personalDashboardUpdate: '/personal_dashboard/update',
      personalDashboardInfo: '/personal_dashboard/info',
      personalDashboardData: '/personal_dashboard/data',
      // 企微号上限
      robotFollowerLimitList: '/robot_follower_limit/list',
      robotFollowerLimitUpdate: '/robot_follower_limit/update',
      // 分配规则组
      dispatchRuleList: '/dispatch_rule/list',
      dispatchRuleCreate: '/dispatch_rule/create',
      dispatchRuleUpdate: '/dispatch_rule/update',
      dispatchRuleDelete: '/dispatch_rule/delete',
      dispatchRuleInfo: '/dispatch_rule/info/:id',
      // 留言统计报表
      leaveCommentsReport: '/leave_comments/report',
      // 留言类型列表
      leaveCommentsConsultingType: '/leave_comments/consulting_type',
      // 常见问题
      faqCategoryList: '/faq/category/list',
      faqCategoryCreate: '/faq/category/create',
      faqCategoryUpdate: '/faq/category/update',
      faqCategoryDelete: '/faq/category/delete',
      faqQuestionList: '/faq/question/list',
      faqQuestionCreate: '/faq/question/create',
      faqQuestionUpdate: '/faq/question/update',
      faqQuestionDelete: '/faq/question/delete',
      faqQuestionTop: '/faq/question/top',
      faqRegionList: '/faq/region/list',
    },
  },
  {
    name: 'ticket',
    paths: {
      // 工单列表 / 详情 / 新建 / 状态流转
      ticketList: '/ticket/list',
      ticketDetail: '/ticket/detail',
      ticketCreate: '/ticket/create',
      ticketStatus: '/ticket/status',
      ticketReport: '/ticket/report',
      // 處理人下拉（全公司在職員工）
      ticketHandlers: '/ticket/handlers',
      // 工单知识库
      ticketKnowledgeList: '/ticket/knowledge/list',
      ticketKnowledgeDetail: '/ticket/knowledge/detail',
      ticketKnowledgeSave: '/ticket/knowledge/save',
      ticketKnowledgeDelete: '/ticket/knowledge/delete',
    },
  },
  {
    name: 'wx',
    paths: {
      externalBindWechat: '/token/external_bind_wechat',
      adminUserBindWechat: '/admin/user/bind_wechat',
      checkWechatBind: '/token/check_bind',
      getTokenByOpenId: '/token/wechat_login',
      miniProgramUrlScheme: '/mini_program/url_scheme',
    },
  },
  {
    name: 'authorize',
    baseUrl: platformAuthorizeHost,
    paths: {
      applyAuthorize: '/api/authorize/wechat',
      parseAuthorize: '/api/authorize/wechat/:code',
    },
  },
  {
    name: 'download',
    paths: {
      getDownLoadToken: '/download/:type/token',
      downloadByType: '/download/:type',
      downloadBusinessLiveCode: '/download/business_livecode',
      downloadOrder: '/download/order',
      // 下载中心
      downloadList: '/download/list',
      downloadFileById: '/download/file/:id',
      downloadFileInfo: '/download/info/:id',
    },
  },
  {
    name: 'xiaoJiGPT',
    baseUrl: XIAOJI_GPT_URL,
    paths: {
      getAnswerList: '/',
      getConsultCandidatesRecommand: '/consult_candidates_recommand',
    },
  },
  {
    name: 'xiaoWenGPT',
    baseUrl: XIAOWEN_GPT_URL,
    paths: {
      getAnswerList: '/DP_DataPlatform/SalesChat/ReplyRecommend',
    },
  },
  {
    name: 'mssvAdmin',
    baseUrl: MSSV_ADMIN_URL,
    paths: {
      userDataAuth: '/api/user/data/auth',
      createLiveCodeTag: '/api/live_code/tag/create',
      editLiveCodeTag: '/api/live_code/tag/edit_state',
      liveCodeTagInfo: '/api/live_code/tag/info',
      liveCodeTagDelete: '/api/live_code/tag/delete',
    },
  },
  {
    name: 'bigData',
    baseUrl: BIG_DATA_URL,
    paths: {
      getH5ServiceCenterFlow: '/DP_ForeignService/ServiceCenterFlowController/h5/getServiceCenterFlow',
    },
  },
  {
    name: 'orderRecord',
    baseUrl: ORDER_RECORD_ADMIN_URL,
    paths: {
      getAgreementList: '/api/agreement',
      productList: '/api/product/external',
      productCollect: '/api/product/collect',
      formExternal: '/api/qrcode/external/form',
    },
  },
];
// 导出时对象为
// {
//   setting: {
//      getList:base + '',
//   },
//   ...
// }
let obj: any = {};
pathList.forEach((i) => {
  const base = i.baseUrl || BASE_URL;
  for (var key in i.paths) {
    if (i.paths.hasOwnProperty(key)) {
      i.paths[key] = base + i.paths[key];
    }
  }
  obj[i.name] = i.paths;
});
export default obj;
